module.exports = __webpack_public_path__ + "img/sol.4e6fecb2.svg";